import { motion } from "framer-motion";
import { FC, PropsWithChildren } from "react";

const MotionBox: FC<PropsWithChildren> = ({ children }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300 }}
      style={{ cursor: "pointer" }}
    >
      {children}
    </motion.div>
  );
};

export default MotionBox;
